import defaultActions from './defaultReduxActions';

const actions = defaultActions({ namespace: 'awaiting-shipping' });

export const { find, create, get, update, patch, reducer, remove } = actions;

export default reducer;
